import { CdkScrollable } from '@angular/cdk/scrolling';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { RouterOutlet } from '@angular/router';
import { map } from 'rxjs';

import { PopupCenterComponent } from '../../popup-center/popup-center.component';
import { UserService } from '../../user';
import { SpinnerComponent } from '../form';
import { LoginComponent } from '../login';
import { CombinedMenuComponent } from './combined-menu';

@Component({
  selector: 'dmb-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
  imports: [CdkScrollable, CombinedMenuComponent, LoginComponent, PopupCenterComponent, RouterOutlet, SpinnerComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MainComponent {
  showLogin = toSignal(inject(UserService).user.pipe(map((u) => !u?.authenticated)));
}
